import * as Api from '@ViewModels';
import { ContactFilterOption } from '../../../components/automation/AutomationStepCard/components/ContactFilterOption';

interface ConditionalFilterProps {
	stepId: string;
	filter: Api.IContactsFilterRequest | null | undefined;
	canEdit: boolean;
	isBusy?: boolean;
	onFilterChange: (filter: Api.IContactsFilterRequest | null) => void;
}

/**
 * Shared component for displaying and editing conditional contact filters.
 * Used across multiple automation step renderers (Email, Texting, ActionItem, etc.)
 * to allow skipping steps based on contact criteria.
 */
export function ConditionalFilter({ stepId, filter, canEdit, isBusy, onFilterChange }: ConditionalFilterProps) {
	return (
		<ContactFilterOption
			canEdit={canEdit}
			skipStepContactFilter={filter}
			stepUuid={stepId}
			stepIsBusy={isBusy || false}
			onFilterChange={onFilterChange}
		/>
	);
}
